import { render, staticRenderFns } from "./usageDetail.vue?vue&type=template&id=352132ec&scoped=true"
import script from "./usageDetail.vue?vue&type=script&lang=js"
export * from "./usageDetail.vue?vue&type=script&lang=js"
import style0 from "./usageDetail.vue?vue&type=style&index=0&id=352132ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352132ec",
  null
  
)

export default component.exports